
import '../styles/Tsapp.css'
import TspVisualizer from './Tspvisualizer.js'

function TsApp() {

  return (
    <>
      <main className="app-container">
      <header className="app-header">
        <h1>Traveling Salesman Problem Visualizer</h1>
        <p>Understand one of computer science's most famous NP-hard problems through interactive visualization</p>
      </header>

      <TspVisualizer />

      <footer className="app-footer">
        <p>Created with React and D3.js</p>
      </footer>
    </main>
      
    </>
  )
}

export default TsApp
